import { GalleryItems } from "src/app/Services/galleries.service";

export interface RecentSale {
  ProductId: string;
  ProductName: string;
  ProductImageUrl: string;
  GalleryName: string;
  SoldPrice: number;
}

export interface NewProduct {
  ArtistId: string;
  ArtistProductId: string;
  Img: string;
  Name: string;
  ArtTypeName: string;
  Price: number;
  AcceptedDate: Date;
  AcceptedDaysAgo: number;
  ResizedImageUrl?: string;
}

export interface GalleryDashboard extends GalleryProductsDashboardResponse {
  TotalConnectedArtist?: number;
  TotatUnSoldArtWorks?: number;
  TotalValueOfUnSoldArtworks?: number;
  ItemsSoldThisYear?: number;
  ItemsSoldThisMonth?: number;
  SalesValueThisYear?: number;
  SalesValueThisMonth?: number;
  TurnoverRate30Days?: number;
  TurnoverRate365Days?: number;
  ChangeInItemsSoldThisYear?: number;
  RevenueThisMonth?: number;
  ChangeInRevenue?: number;
  RevenueYTD?: number;
  TotalItemsInStock?: number;
  TotalConsignmentsThisYear?: number;
  ChangeInTotalConsignmentsThisYear?: number;
  BestPerformingArtistData?: GalleryPerformingTopArtistDashboardResponse[];
  BestPerformingTurnoverRateData?: GalleryPerformingTopArtistDashboardResponse[];
  BestPerformingArtTypeData?: GalleryPerformingTopArtTypesDashboardResponse[];
  Galleries?: any[];
  ConnectedArtist: any[];
  GalleryStockReports: any[];
  IncomingGalleryConnectionRequest: any[];
  ConsignmentApprovalPending: ConsignmentApprovalPendingResponse[];
  ProductRequestPending: ConsignmentApprovalPendingResponse[];
  GallerySalesChartData?: GallerySalesChartResponse[];
}

export class GalleryProductsDashboardResponse {
  RecentSales?: NewProduct[] = [];
  NewProductsAdded?: NewProduct[] = [];
}

export class GalleryPerformingTopArtistDashboardResponse {
  ArtistName!: string;
  SumOfSoldProducts!: number;
  PercentageOfTotal!: number;
  ColorClassBasedOnPercentage?: string;
  TextBasedOnPercentage?: string;
  AverageTurnoverDays!: number;
}

export class GalleryPerformingTopArtTypesDashboardResponse {
  ArtTypeName!: string;
  SumOfSoldProducts!: number;
  PercentageOfTotal!: number;
  ColorClassBasedOnPercentage?: string;
  TextBasedOnPercentage?: string;
}

export class ConsignmentApprovalPendingResponse {
  Name?: string;
  ArtistName?: string;
  PhoneNumber?: string;
  CreatedDate?: Date;
}

export enum GallerySalesInsightsMetrics {
  TotalSalesRevenue = 'TotalSalesRevenue',
  TotalProductSold = 'TotalProductSold',
}

export type GallerySalesInsightsMetricsType = GallerySalesInsightsMetrics.TotalSalesRevenue | GallerySalesInsightsMetrics.TotalProductSold

export enum GalleryInsightsMetricsColors {
  TotalSalesRevenue = '--blue-500',
  TotalProductSold = '--pink-500',
}

export class GallerySalesChartResponse {
  // TimeFrame?: string;
  // GallerySalesRevenue?: string;
  // TotalSoldProductsFromConsignments?: string;
  Metric!: GallerySalesInsightsMetricsType;
  SeriesName!: string; 
  ChartsValue!: ChartsValue[];
}

export class ChartsValue {
  Label!: string;
  DataLabel!: string;
  Value!: number;
}

export class ConnectedArtistResponse {
  Id?: string;
  Name?: string;
  Img?: string;
  ArtistTurnoverRateInDays!: number;
  TotalConsignment!: number;
  TotalArtworks!: number;
  TotalArtworksSold!: number;
  SalesValue!: number;

}